<template>
    <vx-card title="" class="carousel-example">
        <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide>
                <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">ÚTILES ESCOLARES</p>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">PRODUCTO1</p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 2</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 3</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                  <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">SUMINISTROS DE OFICINA</p>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">PRODUCTO1</p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 2</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 3</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                 <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">CUADERNOS</p>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">PRODUCTO1</p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 2</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">PRODUCTO 3</p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p style="font-weight: 900;">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                 <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">ZAPATOS</p>
                    </div>
                        <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">Pantalones</p>
                                        <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                 <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">CINTURONES</p>
                    </div>
                        <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">Pantalones</p>
                                        <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                 <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">PRODUCTOS XYZ</p>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">Pantalones</p>
                                        <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide>
                 <div class="vx-row">
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <p style="font-weight: 900;">PRODUCTO ZYX</p>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2  mb-2">
                                <img :src="card_2.img" alt="content-img" class="responsive card-img-top">
                            </div>
                            <div class="vx-col sm:w-1/2 mb-2">
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">Pantalones</p>
                                        <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                    </span>
                                </div>
                                <div class="flex justify-between flex-wrap">
                                    <span>
                                        <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                    </span>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                          <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_3.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                    <div class="vx-col sm:w-2/2 w-full mb-2">
                           <div class="vx-row">
                                 <div class="vx-col sm:w-1/2  mb-2">
                                    <img :src="card_1.img" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div class="vx-col sm:w-1/2 mb-2">
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">Pantalones</p>
                                            <p class="text-xl"> <b>PRODUCTO 1</b></p>
                                        </span>
                                    </div>
                                    <div class="flex justify-between flex-wrap">
                                        <span>
                                            <p class="text-xl">{{ card_1.footer_text_left_value }}</p>
                                        </span>
                                    </div>
                                </div>
                                <br>
                            </div>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" color="primary" slot="button-prev"></div>
            <div class="swiper-button-next" color="primary" slot="button-next"></div>
          </swiper>
    </vx-card>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import StarRating from 'vue-star-rating'

export default {
    data() {
        return {
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 50,
                // init: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                breakpoints: {
                    1024: {
                        slidesPerView:3,
                        spaceBetween: 40
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    }
                }
            }
        }
    },
    components: {
        swiper,
        swiperSlide,
        StarRating
    },
    created() {


    }
    
}
</script>
